<template>
    <div class="cancelplan-root">
        <div class="root-container">
            <div class="content-top">
                <h1>{{ $t('cancel_complete.title', {
                    planname
                }) }}</h1>
            </div>
            <steps :stepsData="stepsData" :stepsIndex="highLight" class="step-com"></steps>

            <div class="step-two">
                <div class="middle-imme">
                    <p class="package plan-imme">{{$t('cancel_complete.plan_status')}}</p>
                    <p class="imme-time">
                        <template v-if="$store.state.user.showBeta">
                            {{ $t('cancel_complete.beta_note') }}
                        </template>
                        <template v-else>
                            {{$t('cancel_complete.plan_decf')}} <span>{{$t('cancel_complete.plan_decs')}}</span>{{$t('cancel_complete.plan_dect')}}
                        </template>
                    </p>
                </div>
                <div class="middle-text">
                    <p v-html="$t('cancel_complete.notice')"></p>
                </div>

                <div class="make-sureok">
                    <router-link to="/user/dashboard/" class="ui-button primary-button">{{$t('cancel_complete.sure_ok')}}</router-link>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
import steps from '@/basic/Steps';
export default {

    components: {

        steps
    },

    data () {

        return {
            
            planname: this.$route.query.plan_name,
            stepsData: [{
                name: '1',
                value: 1
            },
            {
                name: '2',
                value: 2
            }]

        };

    },

    computed: {

        highLight () {

            let { path } = this.$route;
            return path === '/user/cancel-plan/complete/' ? 1 : 0;

        }

    }

};
</script>

<style lang="less" scoped>
    .cancelplan-root {
        margin: auto;
        max-width: 1200px;
        border:solid 0.01rem #fff;
        border-radius: 0.2rem;
        background-color:#fff;
        .root-container{
           width: 765px;
           margin: auto;
        }
        .content-top {
            text-align: center;
            h1 {
                margin: 0.6rem 0 0.55rem 0;
                font-weight: 700;
                font-size: 0.36rem;
                color: #333;
            }
        }
        
    }
    .middle-imme{
        border-bottom: solid 0.01rem #dddddd;
        padding:0.42rem 0 0.4rem 0;
        margin-bottom: 0.2rem;
        .imme-time{
            font-weight: 500;
            font-size: 0.16rem;
            span{
                font-size: 0.2rem;
            }
        }
    }
    .make-sureok{
        margin:0.7rem 0;
        text-align: center;
    }
    .package.plan-imme{
        display: block;
        margin-bottom:0.2rem;
        font-size: 0.2rem;
        font-weight: 700;
    }
    .package {
        font-weight: 700;
        font-size: 0.2rem;
        margin-bottom: 0.2rem;
    }
    .middle-text {
        p {
            color: #333;
            font-size: 0.16rem;
            font-weight: 400;
        a {
            color: @theme;
            cursor: pointer;
        }
      }
    }

    @media @mobile{
        .cancelplan-root {
            padding: 0 15px;
            box-sizing: border-box;
            .root-container{
                width: 100%;
            }
            .content-top {
                h1 {
                    margin: 1rem 0 0.6rem 0;
                    font-weight: 500;
                    font-size: 0.52rem;
                    color: #333;
                }
            }
            .step-com{
                .steps-item{
                    width:0.44rem;
                    padding: 0 0.44rem;
                }
            }
        }
        .middle-imme{
            border:none;
            padding: 0;
            margin:0;
            .imme-time{
                display: none;
            }
        }
        .make-sureok{
            margin:0.6rem 0 1rem 0;
            .ui-button {
                width:100%;
                box-sizing: border-box;
            }
        }
        .package.plan-imme{
            display: block;
            margin:0.6rem 0 0.3rem 0;
            font-size: 0.32rem;
            font-weight: 500;
        }
        .package {
            font-weight: 500;
            font-size: 0.36rem;
            margin-bottom: 0.3rem;
        }
        .middle-text {
            p {
                color: #333;
                font-size: 0.24rem;
                font-weight: 400;
                a {
                    color: @theme;
                    cursor: pointer;
                    font-weight: 400;
                }
            }
        }

    }
</style>



// WEBPACK FOOTER //
// src/view/cancelPlans/cancelPlanComplete.vue